import React, { useState, useEffect, Suspense, lazy } from 'react'
import './App.css'
import axios from 'axios'
import {Route} from 'react-router-dom'
import {Switch} from 'react-router-dom'
import PrivateRoute from './PrivateRoute'
import AdminRoute from './AdminRoute'
import { AuthContext } from './Context/auth'
import NewtonCradleLoader from './Components/NewtonCradleLoader'
import { TokenContext } from './Context/token'
import checkToken from './Functions/checkToken'
import lazyWithRetry from './Functions/lazyWithRetry'
import NavigationBar from './Components/navbar' 
import { BrowserRouter as Router } from 'react-router-dom'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import Home from './Home'

const Rma = lazy(() => import('./Rma'))
const Kdm = lazy(() => import('./Kdm'))
const Ping = lazy(() => import('./Ping'))
const PingRefactor = lazyWithRetry(() => import('./PingRefactor'), 'ping-refactor-route')
const Keys = lazy(() => import('./Keys'))
const Tools = lazy(() => import('./Tools'))
const Terms = lazy(() => import('./Terms'))
const Users = lazy(() => import('./Users'))
const Cases = lazy(() => import('./Cases'))
const Reset = lazy(() => import('./Reset'))
const Login = lazy(() => import('./Login'))
const Access = lazy(() => import('./Access'))
const Sensor = lazy(() => import('./Sensor'))
const Client = lazy(() => import('./Client'))
const Orders = lazy(() => import('./Orders'))
const Owners = lazy(() => import('./Owners'))
const Status = lazy(() => import('./Status'))
const Privacy = lazy(() => import('./Policy'))
const Reports = lazy(() => import('./Reports'))
const ReportsRefactor = lazy(() => import('./ReportsRefactor'))
const Dealers = lazy(() => import('./Dealers'))
const Billing = lazy(() => import('./Billing'))
const Monitor = lazy(() => import('./Monitor'))
const Control = lazy(() => import('./Control'))
const ControlRefactor = lazyWithRetry(() => import('./ControlRefactor'), 'control-refactor-route')
const License = lazy(() => import('./License'))
const Passkey = lazy(() => import('./Passkey'))
const Cleaners = lazy(() => import('./Cleaners'))
const FollowUp = lazy(() => import('./FollowUp'))
const Tracking = lazy(() => import('./Tracking'))
const Schedule = lazy(() => import('./Schedule'))
const PmDetail = lazy(() => import('./PmDetail'))
const Providers = lazy(() => import('./Providers'))
const Inventory = lazy(() => import('./Inventory'))
const Locations = lazy(() => import('./Locations'))
const Equipment = lazy(() => import('./Equipment'))
const BulbOrder = lazy(() => import('./BulbOrder'))
const AddSensor = lazy(() => import('./AddSensor'))
const CaseDetail = lazy(() => import('./CaseDetail'))
const EditSensor = lazy(() => import('./EditSensor'))
const LogAnalyzer = lazy(() => import('./LogAnalyzer'))
const ScreenAudit = lazy(() => import('./ScreenAudit'))
const BoothImages = lazy(() => import('./BoothImages'))
const UploadImage = lazy(() => import('./UploadImage'))
const ClosedCases = lazy(() => import('./ClosedCases'))
const AddInventory = lazy(() => import('./AddInventory'))
const PlaybackEvent = lazy(() => import('./PlaybackEvent'))
const AccessSession = lazy(() => import('./AccessSession'))
const ResetPassword = lazy(() => import('./ResetPassword'))
const ForgotUsername = lazy(() => import('./ForgotUsername'))
const StatusSections = lazy(() => import('./StatusSections'))
const Acknowledgement = lazy(() => import('./Acknowledgement'))
const Troubleshooting = lazy(() => import('./Troubleshooting'))
const EquipmentDetail = lazy(() => import('./EquipmentDetail'))
const RedirectSession = lazy(() => import('./RedirectSession'))
const UpdateEquipment = lazy(() => import('./UpdateEquipment'))
const AnalyzerResults = lazy(() => import('./AnalyzerResults'))
const NewtonResponse = lazy(() => import('./NewtonResponsePage'))
const ContentAlertDetails = lazy(() => import('./ContentAlertDetailsPage'))
const SensorEscalation = lazy(() => import('./SensorEscalation'))
const NewtonSnmpBuilder = lazy(() => import('./NewtonSnmpBuilder'))
const NewtonTrapBuilder = lazy(() => import('./NewtonTrapBuilder'))
const ScreenAuditResults = lazy(() => import('./ScreenAuditResults'))
const PerformScreenAudit = lazy(() => import('./PerformScreenAudit'))
const NewtonApiBuilder = lazy(() => import('./NewtonApiToolBuilder'))
const NewtonClientUpdater = lazy(() => import('./NewtonClientUpdater'))
const NewtonResponseBuilder = lazy(() => import('./NewtonResponseBuilder'))
const NewtonAudioFormatBuilder = lazy(() => import('./NewtonAudioFormatBuilder'))
const NewtonTempIncidentAdvice = lazy(() => import('./NewtonTempIncidentAdvice'))
const NewtonPromptPacketBuilder = lazy(() => import('./NewtonPromptPacketBuilder'))
const NewtonMessageRecipeBuilder = lazy(() => import('./NewtonMessageRecipeBuilder'))
const NewtonProtocolToolBuilder = lazy(() => import('./NewtonProtocolToolBuilder'))
const NewtonIngestSourceBuilder = lazy(() => import('./NewtonIngestSourceBuilder'))
const NewtonSnmpSubvalueBuilder = lazy(() => import('./NewtonSnmpTrapSubvalueBuilder'))
const NewtonScriptTemplateBuilder = lazy(() => import('./NewtonScriptTemplateBuilder'))
const NewtonNoSalesShutdown = lazy(() => import('./NewtonNoSalesShutdown'))
const NewtonSetupNavigation = lazy(() => import('./Components/NewtonSetupNavigation'))
const NewtonEquipmentGuiScreenBuilder = lazy(() => import('./NewtonEquipmentGuiScreenBuilder'))
const NewtonGlobalToolStrategyBuilder = lazy(() => import('./NewtonGlobalToolStrategyBuilder'))
const NewtonScriptTemplateTargetBuilder = lazy(() => import('./NewtonScriptTemplateTargetBuilder'))
const NewtonScriptRunAuditor = lazy(() => import('./NewtonScriptRunAuditor'))
const NewtonAuditOverview = lazy(() => import('./NewtonAuditOverview'))
const NewtonAuditActivity = lazy(() => import('./NewtonAuditActivity'))
const NewtonAuditErrors = lazy(() => import('./NewtonAuditErrors'))
const NewtonAuditCommunications = lazy(() => import('./NewtonAuditCommunications'))
const NewtonContentCatalog = lazy(() => import('./NewtonContentCatalog'))
const AssetLibrary = lazy(() => import('./AssetLibrary'))
const SystemArchitecture = lazy(() => import('./SystemArchitecture'))
const NewtonChat = lazy(() => import('./NewtonChat'))



const CasesRefactor = lazy(() => import('./CasesRefactor'))
const ClosedCasesRefactor = lazyWithRetry(() => import('./ClosedCasesRefactor'), 'closed-cases-refactor-route')
const AccessRefactor = lazy(() => import('./AccessRefactor'))
const AccessSessionRefactor = lazy(() => import('./AccessSessionRefactor'))
const LocationShowSchedule = lazy(() => import('./LocationShowSchedule'))
const RmaRefactor = lazy(() => import('./RmaRefactor'))
const PmRefactor = lazy(() => import('./PmRefactor'))
const PmDetailRefactor = lazy(() => import('./PmDetailRefactor'))
const KeysRefactor = lazy(() => import('./KeysRefactor'))
const OrdersRefactor = lazy(() => import('./OrdersRefactor'))
const OwnersRefactor = lazy(() => import('./OwnersRefactor'))
const LocationsRefactor = lazy(() => import('./LocationsRefactor'))
const UploadImageRefactor = lazy(() => import('./UploadImageRefactor'))
const CaseDetailRefactor = lazy(() => import('./CaseDetailRefactor'))
const SensorsRefactor = lazy(() => import('./SensorsRefactor'))
const SensorEscalationRefactor = lazy(() => import('./SensorEscalationRefactor'))
const TrackingRefactor = lazy(() => import('./TrackingRefactor'))
const TmsLicenseRefactor = lazy(() => import('./TmsLicenseRefactor'))
const DealersRefactor = lazy(() => import('./DealersRefactor'))
const PasskeysRefactor = lazy(() => import('./PasskeysRefactor'))
const CleanersRefactor = lazy(() => import('./CleanersRefactor'))
const FollowUpRefactor = lazy(() => import('./FollowUpRefactor'))
const InventoryRefactor = lazyWithRetry(() => import('./InventoryRefactor'), 'inventory-refactor-route')
const EquipmentRefactor = lazyWithRetry(() => import('./EquipmentRefactor'), 'equipment-refactor-route')
const EquipmentDetailRefactor = lazyWithRetry(() => import('./EquipmentDetailRefactor'), 'equipment-detail-refactor-route')
const ProvidersRefactor = lazyWithRetry(() => import('./ProvidersRefactor'), 'providers-refactor-route')
const LoginRefactor = lazyWithRetry(() => import('./LoginRefactor'), 'login-refactor-route')
const ResetPasswordRefactor = lazyWithRetry(() => import('./ResetPasswordRefactor'), 'reset-password-refactor-route')
const ResetRefactor = lazyWithRetry(() => import('./ResetRefactor'), 'reset-token-refactor-route')
const ForgotUsernameRefactor = lazyWithRetry(() => import('./ForgotUsernameRefactor'), 'forgot-username-refactor-route')
const UsersRefactor = lazyWithRetry(() => import('./UsersRefactor'), 'users-refactor-route')
const ScreenAuditRefactor = lazyWithRetry(() => import('./ScreenAuditRefactor'), 'screen-audit-refactor-route')
const PerformScreenAuditRefactor = lazyWithRetry(() => import('./PerformScreenAuditRefactor'), 'perform-screen-audit-refactor-route')
const ScreenAuditResultsRefactor = lazyWithRetry(() => import('./ScreenAuditResultsRefactor'), 'screen-audit-results-refactor-route')

const App = () => {

  const existingTokens = JSON.parse(localStorage.getItem('tokens'))
  const [authTokens, setAuthTokens] = useState(existingTokens)
  const [tokenState, setTokenState] = useState(false)
  const [title, setTitle] = useState('FX cinema software')
  const [faviconUrl, setFaviconUrl] = useState('/fx.ico')

  useEffect(() => {
    const getHostName = async () => {
      try {
        const getHost = await axios.post('/getHost')
        const routeTitle = {
          '/refactor/dealers': 'Dealers',
          '/refactor/passkeys': 'Passkeys',
          '/refactor/cleaners': 'Cleaners',
          '/refactor/closedCases': 'Closed Cases',
          '/refactor/followup': 'Follow Up',
          '/refactor/reports': 'Reports',
          '/refactor/tmsLicense': 'TMS Licenses',
          '/refactor/equipment': 'Equipment',
          '/refactor/equipmentDetail': 'Equipment Detail',
          '/refactor/providers': 'Service Providers',
          '/refactor/login': 'Login',
          '/refactor/resetPassword': 'Reset Password',
          '/refactor/forgotUsername': 'Forgot Username',
          '/refactor/users': 'Users',
          '/refactor/screenaudit': 'Screen Audit',
          '/refactor/performaudit': 'Perform Screen Audit',
          '/refactor/auditresults': 'Screen Audit Results',
          '/newton/audit': 'Newton Audit',
          '/newton/audit/activity': 'Newton Audit Activity',
          '/newton/audit/errors': 'Newton Audit Errors',
          '/newton/audit/communications': 'Newton Audit Communications'
        }[window.location.pathname]

        if (routeTitle) {
          setTitle(routeTitle)
          return
        }

        if (getHost.data.host === 'doantheatreservices.com' || getHost.data.host === 'doantheaterservices.com' || getHost.data.host === 'doannoc.com') {
          setFaviconUrl('/doan.ico')
          setTitle('Doan Theatre Services')
        }
        if (getHost.data.host === 'developmentfx.com') {
          setTitle(`FX Development`)
        }
      } catch (e) {
        console.log(e)
      }
    }
    getHostName()
  }, []);

  useEffect(() => {
    // Update the favicon when the URL changes
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = faviconUrl;
    document.getElementsByTagName('head')[0].appendChild(link);
  }, [faviconUrl]);

  useEffect(() => {
    const existingTokens = JSON.parse(localStorage.getItem('tokens'))
    let hasToken = false
    if (existingTokens !== null) {
      hasToken = checkToken(existingTokens)
    }
    setTokenState(hasToken)
  }, [tokenState])

  const setTokens = (data) => {
    localStorage.setItem('tokens', JSON.stringify(data))
    setAuthTokens(data)
    localStorage.setItem('tokenStatus', JSON.stringify(true))
  }

  const stateOfToken = () => {
    const existingTokens = JSON.parse(localStorage.getItem('tokens'))
    let hasToken = false
    if (existingTokens !== null) {
      hasToken = checkToken(existingTokens)
    }
    setTokenState(hasToken)
  }


  return (
    <AuthContext.Provider value={{ authTokens, setAuthTokens: setTokens }}>
      <TokenContext.Provider value={{ tokenState, setTokenState: stateOfToken }}>
        <React.Fragment>
          <Router>
            <NavigationBar token={tokenState} />
            <title>{title}</title>
            <Suspense fallback={
              <div className='newton-route-loader'>
                <NewtonCradleLoader label='Loading page' size='lg' />
              </div>
            }>
              <Switch>
                <Route exact path='/' component={Home} />
                {/* REFACTORED: Login */}
                <Route path='/login' component={Login} />
								{/* REFACTORED: Terms */}
                <Route path='/terms' component={Terms} />
								{/* kdm no refactor needed */}
								<PrivateRoute path='/kdm' component={Kdm} />
								{/* REFACTORED: RMA */}
                <PrivateRoute path='/rma' component={Rma} />
								{/* REFACTORED: privacy */}
                <Route path='/privacy' component={Privacy} />

								{/* REFACTORED: Keys */}
                <PrivateRoute path='/keys' component={Keys} />
                {/* REFACTORED: Ping */}
                <PrivateRoute path='/ping' component={Ping} />
								{/* REFACTORED: PM */}
                <PrivateRoute path='/pm' component={Schedule} />
                {/* REFACTORED: Reset password token */}
                <Route path='/reset/:token' component={Reset} />
                {/* REFACTORED: Users */}
                <PrivateRoute path='/users' component={Users} />
								{/* REFACTORED: Cases */}
                <PrivateRoute path='/cases' component={Cases} />
                <PrivateRoute path='/client' component={Client} />
                {/* REFACTORED: Orders */}
                <PrivateRoute path='/orders' component={Orders} />
                {/* REFACTORED: Owners */}
                <PrivateRoute path='/owners' component={Owners} />
								{/*Refactor not needed. Dropping*/}
                <PrivateRoute path='/status' component={Status} />
								{/* REFACTORED: access */}
                <PrivateRoute path='/access' component={Access} />
                {/* REFACTORED: Sensors */}
                <PrivateRoute path='/sensors' component={Sensor} />
                {/* REFACTORED: Control */}
                <PrivateRoute path='/control' component={Control} />
                {/* REFACTORED: TMS License */}
                <PrivateRoute path='/license' component={License} />
                {/* REFACTORED: Dealers */}
                <PrivateRoute path='/dealers' component={Dealers} />
                <PrivateRoute path='/billing' component={Billing} />
                <PrivateRoute path='/monitor' component={Monitor} />
								{/* REFACTORED: Reports */}
								<PrivateRoute path='/reports' component={Reports} />
                {/* REFACTORED: Passkeys */}
                <PrivateRoute path='/passkeys' component={Passkey} />
                {/* REFACTORED: Cleaners */}
                <PrivateRoute path='/cleaners' component={Cleaners} />
                {/* REFACTORED: Follow up */}
                <PrivateRoute path='/followup' component={FollowUp} />
                {/* REFACTORED: Tracking */}
                <PrivateRoute path='/tracking' component={Tracking} />
                {/* REFACTORED: PM Detail */}
                <PrivateRoute path='/pmDetail' component={PmDetail} />
								{/* REFACTORED: Location */}
                <PrivateRoute path='/location' component={Locations} />
								{/* REFACTORED: Inventory */}
                <PrivateRoute path='/inventory' component={Inventory} />
								{/* content no refactor needed */}
                <PrivateRoute path='/content' component={NewtonContentCatalog} />
								{/* asset library no refactor needed */}
                <AdminRoute path='/assetLibrary' component={AssetLibrary} />
								{/* system architechure no refactor needed */}
                <AdminRoute exact path='/systemArchitecture' component={SystemArchitecture} />
                {/* REFACTORED: Equipment */}
                <PrivateRoute path='/equipment' component={Equipment} />
                {/* REFACTORED: Service Providers */}
                <PrivateRoute path='/providers' component={Providers} />
								{/* Refactor not needed*/ }
                <PrivateRoute path='/addSensor' component={AddSensor} />
                <Route path='/bulbOrder/:token' component={BulbOrder} />
								{/* REFACTORED: Reset password request */}
                <Route path='/resetPassword' component={ResetPassword} />
								{/* Refactor not needed*/ }
                <PrivateRoute path='/editSensor' component={EditSensor} />
								{/* REFACTORED: case detail */}
                <PrivateRoute path='/caseDetail' component={CaseDetail} />
                <PrivateRoute path='/boothPics' component={BoothImages} />
                {/* REFACTORED: Forgot username */}
                <Route path='/forgotUsername' component={ForgotUsername} />
                {/* REFACTORED: Screen audit */}
                <PrivateRoute path='/screenaudit' component={ScreenAudit} />
                {/* REFACTORED: Closed cases */}
                <PrivateRoute path='/closedCases' component={ClosedCases} />
                {/* REFACTORED: Upload image */}
                <PrivateRoute path='/uploadImage' component={UploadImage} />
								{/* Refactor not needed*/ }
                <PrivateRoute exact path='/newton' component={NewtonChat} />
                <PrivateRoute path='/logAnalysis' component={LogAnalyzer} />
								{/* Refactor not needed*/ }
								<PrivateRoute path='/playbackEvent' component={PlaybackEvent} />
								{/* Refactor not needed*/ }
                <PrivateRoute path='/statusSections' component={StatusSections} />
								{/* Refactor not needed*/ }
								<Route path='/newton/response/:token' component={NewtonResponse} />
								{/* Refactor not needed*/ }
								<Route path='/newton/content-alert/:token' component={ContentAlertDetails} />
                <PrivateRoute path='/updateEquipment' component={UpdateEquipment} />
								{/* Refactor not needed*/ }
                <Route path='/redirectSession/:token' component={RedirectSession} />
								{/* Refactor not needed*/ }
                <Route path='/troubleshooting/:token' component={Troubleshooting} />
                {/* REFACTORED: Equipment Detail */}
                <PrivateRoute path='/equipmentDetail' component={EquipmentDetail} /> 
                {/* REFACTORED: Perform screen audit */}
                <PrivateRoute path='/performaudit' component={PerformScreenAudit} />
                {/* REFACTORED: Screen audit results */}
                <PrivateRoute path='/auditresults' component={ScreenAuditResults} />
                <Route path='/acknowledgement/:token' component={Acknowledgement} />
                <Route path='/analyzerResults/:token' component={AnalyzerResults} />
                {/* REFACTORED: Sensor escalation */}
                <PrivateRoute path='/sensorEscalation' component={SensorEscalation} />
                <Route path='/addinventory/:orderLinkNumber' component={AddInventory} />
								{/* REFACTORED: access session */}
                <PrivateRoute path='/accessSession/:token' component={AccessSession} />

                <PrivateRoute path='/newton/setup' component={NewtonSetupNavigation} />
								<AdminRoute path='/newton/noSalesShutdown' component={NewtonNoSalesShutdown} />
								<PrivateRoute path='/newton/apiBuilder' component={NewtonApiBuilder} />
								<PrivateRoute path='/newton/snmpTraps' component={NewtonTrapBuilder} />
								<PrivateRoute path='/newton/snmpBuilder' component={NewtonSnmpBuilder} />

								<PrivateRoute path='/newton/ingestSource' component={NewtonIngestSourceBuilder} />
								<PrivateRoute path='/newton/clientUpdater' component={NewtonClientUpdater} />
								<PrivateRoute path='/newton/responseClasses' component={NewtonResponseBuilder} />
								<PrivateRoute path='/newton/snmpSubvalue' component={NewtonSnmpSubvalueBuilder} />
								<PrivateRoute path='/newton/promptPacket' component={NewtonPromptPacketBuilder} />
								<PrivateRoute path='/newton/messageRecipe' component={NewtonMessageRecipeBuilder} />
								<PrivateRoute path='/newton/protocolTools' component={NewtonProtocolToolBuilder} />
								<PrivateRoute path='/newton/incidentAdvice' component={NewtonTempIncidentAdvice} />
								<PrivateRoute path='/newton/guiScreen' component={NewtonEquipmentGuiScreenBuilder} />
								<PrivateRoute path='/newton/scriptTemplate' component={NewtonScriptTemplateBuilder} />
								<PrivateRoute path='/newton/globalTools' component={NewtonGlobalToolStrategyBuilder} />
								<PrivateRoute path='/newton/soundProcessorFormat' component={NewtonAudioFormatBuilder} />
								<PrivateRoute path='/newton/scriptTemplateTarget' component={NewtonScriptTemplateTargetBuilder} />
								<AdminRoute exact path='/newton/audit' component={NewtonAuditOverview} />
								<AdminRoute path='/newton/audit/activity' component={NewtonAuditActivity} />
								<AdminRoute path='/newton/audit/errors' component={NewtonAuditErrors} />
								<AdminRoute path='/newton/audit/communications' component={NewtonAuditCommunications} />
								<AdminRoute path='/newton/scriptRuns' component={NewtonScriptRunAuditor} />

								<PrivateRoute path='/refactor/cases' component={CasesRefactor} />
                <PrivateRoute path='/refactor/caseDetail' component={CaseDetailRefactor} />
                <PrivateRoute path='/refactor/access' component={AccessRefactor} />
                <PrivateRoute exact path='/refactor/control' component={ControlRefactor} />
                <PrivateRoute exact path='/refactor/ping' component={PingRefactor} />
                <PrivateRoute path='/refactor/rma' component={RmaRefactor} />
                <PrivateRoute path='/refactor/pmDetail' component={PmDetailRefactor} />
                <PrivateRoute path='/refactor/pm' component={PmRefactor} />
                <PrivateRoute path='/refactor/keys' component={KeysRefactor} />
                <PrivateRoute path='/refactor/orders' component={OrdersRefactor} />
                <PrivateRoute path='/refactor/owners' component={OwnersRefactor} />
                <PrivateRoute path='/refactor/location' component={LocationsRefactor} />
                <PrivateRoute path='/refactor/uploadImage' component={UploadImageRefactor} />
                <PrivateRoute path='/refactor/sensors' component={SensorsRefactor} />
                <PrivateRoute exact path='/refactor/sensorEscalation' component={SensorEscalationRefactor} />
                <PrivateRoute path='/refactor/tracking' component={TrackingRefactor} />
                <PrivateRoute path='/refactor/tmsLicense' component={TmsLicenseRefactor} />
                <PrivateRoute path='/refactor/dealers' component={DealersRefactor} />
								<PrivateRoute path='/refactor/reports' component={ReportsRefactor} />
								<PrivateRoute exact path='/refactor/closedCases' component={ClosedCasesRefactor} />
								<PrivateRoute path='/refactor/passkeys' component={PasskeysRefactor} />
								<PrivateRoute path='/refactor/cleaners' component={CleanersRefactor} />
								<PrivateRoute path='/refactor/followup' component={FollowUpRefactor} />
								<PrivateRoute path='/refactor/inventory' component={InventoryRefactor} />
								<PrivateRoute exact path='/refactor/equipmentDetail' component={EquipmentDetailRefactor} />
								<PrivateRoute exact path='/refactor/equipment' component={EquipmentRefactor} />
								<PrivateRoute exact path='/refactor/providers' component={ProvidersRefactor} />
								<PrivateRoute exact path='/refactor/users' component={UsersRefactor} />
								<PrivateRoute exact path='/refactor/screenaudit' component={ScreenAuditRefactor} />
								<PrivateRoute exact path='/refactor/performaudit' component={PerformScreenAuditRefactor} />
								<PrivateRoute exact path='/refactor/auditresults' component={ScreenAuditResultsRefactor} />
								<Route exact path='/refactor/login' component={LoginRefactor} />
								<Route exact path='/refactor/resetPassword' component={ResetPasswordRefactor} />
								<Route exact path='/refactor/forgotUsername' component={ForgotUsernameRefactor} />
								<Route exact path='/refactor/reset/:token' component={ResetRefactor} />

								<PrivateRoute path='/accessSessionRefactor/:accessId' component={AccessSessionRefactor} />
                <PrivateRoute path='/locationShowSchedule' component={LocationShowSchedule} />

              </Switch>
            </Suspense>
          </Router>
        </React.Fragment>
      </TokenContext.Provider>
    </AuthContext.Provider>
  )
}

export default App
